<template>
  <div>
    <transition name="fade">
      <div
          v-show="loading"
          class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
      >
        <Loader class="center-h-v" />
      </div>
    </transition>

    <div class="m-2" style="border-radius: 0.5rem;">
      <el-collapse
          accordion
          v-model="activeItem"
          @change="handleItemClick"
          v-for="(employeeObjectives, type) in reviewGroups"
          :key="type"
          :class="type"
      >
        <el-collapse-item
            :name="objective.ObjectiveId"
            v-for="objective in employeeObjectives"
            :key="objective.ObjectiveId"
            class="mt-3"
        >
          <template slot="title">
            <div class="complete-circle"></div>
            <h1 class="font-bolder">{{ objective.GoalName }}</h1>
          </template>

          <main class="bg-gray-200 py-2 px-4 w-full" v-if="infoByReviewId[objective.ObjectiveId]">
            <section class="w-full my-2">
              <div class="flex w-full items-center gap-4">
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Name:</h1>
                  <small class="text-sm">{{ objective.GoalName }}</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Measure:</h1>
                  <small class="text-sm">{{ objective.GoalMeasure }}</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Weight:</h1>

                  <small class="text-sm"
                  >{{ objective.Weight ? objective.Weight : 0 }}%
                  </small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Target:</h1>
                  <small class="text-sm">{{ objective.Target }}</small>
                  <small class="text-sm">{{ objective.Status }}</small>
                </div>
              </div>
            </section>
            <article class="my-2">
              <header>
                <h1 class="font-bold text-lg">Description</h1>
              </header>
              <div>
                <p v-if="!loading">{{ objective.Description }}</p>
                <el-skeleton
                    :rows="3"
                    animated
                    v-if="loading"
                    :loading="loading"
                    variant="text"
                    style="width: 80%"
                />
              </div>
            </article>
            <section class="bg-white w-full rounded-lg">
              <header
                  class="w-full border-b-1.5 flex justify-between items-center"
              >
                <h1 class="text-lg font-bold p-2">My Assessment</h1>
                <!-- {{ activeReview }} -->

                <div class="flex gap-2">
                  <p
                      :style="{
                      'background-color':
                        info[0].ObjectiveStatus === 'Draft'
                          ? '#87CEEB'
                          : '#4CAF50',
                      color: '#fff',
                      padding: '1px 8px',
                      'border-radius': '5px',
                    }"
                      class="mr-2"
                  >
                    {{ info[0].ObjectiveStatus }}
                  </p>
                </div>
              </header>
              <main class="flex flex-col gap-2"  >
                <section class="flex gap-2">
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Achieved Target</h1>
                      <el-skeleton
                          :rows="1"
                          animated
                          v-if="loading"
                          :loading="loading"
                          variant="text"
                          style="width: 80%"
                      />

                      <input
                          v-if="!loading"
                          :type="objective.GoalMeasure"
                          value=""
                          placeholder="6 Trainings"
                          class="bg-gray-200"
                          v-model="info[0].AchievedTarget"
                          required
                          onfocus="(this.type='date')"
                          onblur="(this.type='text')"
                      />
                    </div>
                  </div>
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Attachment</h1>
                      <el-skeleton
                          :rows="1"
                          animated
                          v-if="loading"
                          :loading="loading"
                          variant="text"
                          style="width: 80%"
                      />
                      <input
                          v-if="!loading && !info.Attachment"
                          type="file"
                          multiple
                          value=""
                          class="bg-gray-200 p-2"
                          v-on:change="getFile"
                      />
                      <el-button
                          v-if="!loading && info.Attachment"
                          type="plain"
                          @click="showAttachedDocs = true"
                      >View Attached Files</el-button
                      >
                    </div>
                  </div>

                  <div class="flex w-full items-center p-2">
                    <div class="flex w-full items-center p-2">
                      <div class="flex flex-col w-full">
                        <h1 class="font-bold text-lg">Rating</h1>

                        <el-skeleton
                            :rows="1"
                            animated
                            v-if="loading"
                            :loading="loading"
                            variant="button"
                            style="width: 80%"
                        />
                        <select
                            v-if="!loading"
                            class="bg-gray-200"
                            v-model="info[0].Rating"
                            required
                        >
                          <option value="5">Exceeding Expectations</option>
                          <option value="4">Meeting Expectations</option>
                          <option value="3">
                            Meeting Expectations with Reservations
                          </option>
                          <option value="2">Approaching Expectations</option>
                          <option value="1">Below Expectations</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </section>
                <div class="p-4">
                  <label>Comment </label>
                  <el-skeleton
                      :rows="3"
                      animated
                      v-if="loading"
                      :loading="loading"
                      variant="text"
                      style="width: 90%"
                  />
                  <textarea
                      v-if="!loading"
                      name="myreview-comment"
                      id="myreview-comment"
                      cols="5"
                      rows="5"
                      class="w-full p-2 border-1.5 rounded bg-gray-200"
                      style="width: 100% !important"
                      v-model="info[0].Comment"
                  ></textarea>
                </div>
              </main>
            </section>

          </main>
        </el-collapse-item>
      </el-collapse>
<!--      <div
          v-if="!loading && reviews.length == 0"
          class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>-->
    </div>
    <PerfReviewAttachments
        :showAttachedDocs="showAttachedDocs"
        :info="info"
        @close="showAttachedDocs = false"
    ></PerfReviewAttachments>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import PerfReviewAttachments from '@/components/employees/modals/perfReviewAttachments.vue';

export default {
  name: 'MyReviewsGoals',
  props:["employeeObjectives"],
  components: {  Loader, PerfReviewAttachments },
  data() {
    return {
      showGoal: false,
      loading: false,
      showAttachedDocs: false,
      activeItem: '',
      infoByReviewId: {},
      info: {
        ObjectiveReviewId: '',
        ObjectiveId: '',
        ObjectiveStatus: 'Draft',
        ReviewType: 'Mine',
        Rating: '',
        AchievedTarget: '',
        Attachment: '',
        Comment: '',
      },
      columns: [
        {
          field: 'Name',
          key: 'a',
          title: 'Objective Name',
          renderBodyCell: ({ row }) => {
            return (
                <p
                    on-click={() => (this.showGoal = true)}
                    class='text-blue-500 cursor-pointer'
                >
                  {row.Name}
                </p>
            );
          },
        },
        { field: 'Category', key: 'b', title: 'Category' },
        /*  { field: "DueDate", key: "c", title: "Due Date" }, */
        {
          field: 'MyReview',
          key: 'x',
          title: 'My Review',
        },
        {
          field: 'Attachment',
          key: 'd',
          title: 'Attachment',
          renderBodyCell: () => {
            return <p class='cursor-pointer font-bold'>&#128206;</p>;
          },
        },
        {
          field: 'Feedback',
          key: 'f',
          title: 'Feedback',
          renderBodyCell: () => {
            return (
                <img
                    class='h-6 object-contain cursor-pointer px-5'
                    src='@/assets/icons/cross-white.png'
                />
            );
          },
        },
      ],
      reviews: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    reviewGroups() {
      return {
        pending: this.pending,
        drafts: this.drafts,
        completed: this.completed,
      };
    },
  },
  methods: {
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
      const blob = new Blob([file], { type: '*' });
      this.preview = URL.createObjectURL(blob);
    },
    handleItemClick(ObjectiveReviewId) {
      let activeReview = this.employeeObjectives.find(
          (review) => review.ObjectiveId === ObjectiveReviewId
      ).Reviews;
      let myReviews = activeReview.filter((review) => review.ReviewType === 'Mine');

      if (!myReviews.length) {
        myReviews = [
          {
            AchievedTarget: '',
            Attachment: '',
            Comment: '',
            Created: '',
            CreatedBy: '',
            Id: '',
            ModifiedBy: '',
            ObjectiveStatus: '',
            Rating: null,
            ReviewType: '',
            Updated: '',
          },
        ];
      }
      this.$set(this.infoByReviewId, ObjectiveReviewId, {
        ObjectiveReviewId,
        myReview: myReviews,
      });
      this.info = {
        ObjectiveReviewId,
        ...this.info,
        ...myReviews,
      };
      this.loading = false;
      console.log(this.info)
    },


    fetchData() {
      this.completed = this.employeeObjectives.filter(item=>item.Reviews.some(review=>review.ReviewType==="Mine" && review.ObjectiveStatus==="Submitted"))
      this.drafts = this.employeeObjectives.filter(item=>item.Reviews.some(review=>review.ReviewType==="Mine" && review.ObjectiveStatus==="Draft"))
      this.pending = this.employeeObjectives.filter(item=>item.Reviews.length===0)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const apiUrl = `${this.getOrganization}/performance/objective/mine/${this.$ApiVersion}/request`;

      axios
          .get(apiUrl, options)
          .then((response) => {
            if (response.data.StatusCode == 200) {
              this.reviews = response.data.Data;
              this.loading = false;
            } else {
              this.$notify.error({
                title: 'Failure',
                message: 'Error occured while fetching data.',
              });
            }
          })
          .catch((error) => {
            this.$notify.error({
              title: 'Failure',
              message: 'Error occured while fetching records.',
            });
            console.error('Error fetching data:', error);
          });
    },
    getStatusImagePath(status) {
      return require(`@/assets/icons/status-${status}.png`);
    },
    refresh() {
      this.fetchData();
    },

    async postData(data, isDraft) {
      this.loading = true;
      const action = isDraft ? 'add' : 'edit';
      const verb = isDraft ? 'post' : 'put';
      let response;
      try {
        const apiUrl = `${this.getOrganization}/performance/objective/review/${this.$ApiVersion}/${action}`;

        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'multipart/form-data',
          },
        };

        response = await axios[verb](apiUrl, data, options);

        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });
          this.fetchData();
        } else {
          this.loading = false;
          throw new Error(`Unexpected status code: ${response.status}`);
        }
      } catch (error) {
        this.loading = false;
        this.loading = false;
        this.$notify.error({
          title: 'Failure',
          message: response.data.StatusMessage,
        });
        console.error('Error in API call:', error);
      }
    },
    handleSubmit(status) {
      {
        /* alert(status); */
      }
      const formData = new FormData();

      formData.append(
          'ObjectiveId',
          status === 'draft' ? this.activeItem : this.info.ReviewId
      );
      formData.append('ObjectiveReviewId', this.info.ReviewId);
      formData.append('ReviewType', 'Mine');
      formData.append('Rating', parseInt(this.info.Rating, 10));
      formData.append('AchievedTarget', this.info.AchievedTarget);
      formData.append('Attachment', this.info.Attachment);
      formData.append('Comment', this.info.Comment);
      if (status === 'final') {
        formData.append('ObjectiveStatus', 'Submitted');

        this.postData(formData, false);
      } else {
        formData.append('ObjectiveStatus', 'Draft');

        this.postData(formData, true);
      }
    },
  },
};
</script>
<style>
.el-collapse-item__header {
  background-color: lightgrey !important;
  padding: 0.1rem 1rem;
  border-radius: 0.5rem;
}
</style>
